export const INITIAL_LIMIT = 8;
export const SHIPPING_COST = 500;
